import Alpine from "alpinejs";

Alpine.data('blogPostsOverview', (filter) => ({
    itemsCount: 0,
    itemsShown: 4,
    showMoreButton: true,
    filter: filter || '',
    init() {
        this.items = this.$el.querySelector('.blog-posts-overview__items').childNodes;
        this.itemsCount = this.items.length;
        this.showMoreButton = this.itemsCount > this.itemsShown;

        Array.from(this.items).forEach((item, index) => {
            if (index >= this.itemsShown) {
                item.classList.add('hidden');
            }
        });

        if (this.filter) {
            this.updateItems();
        }
    },
    updateFilter(newFilter) {
        this.filter = newFilter;
        this.itemsShown = 4;
        this.updateItems();
    },
    showMore() {
        this.itemsShown += 4;
        this.updateItems();
    },
    updateItems() {
        let visibleItems = 0;
        let animationInItems = 0;
        this.showMoreButton = false;
        this.items.forEach((item) => {
            const matchesFilter =
                this.filter === '' || item.dataset.tags?.toLowerCase().includes(this.filter?.toLowerCase());
            if (!matchesFilter) {
                item.classList.add('hidden');
                return;
            }
            if (this.itemsShown > visibleItems) {
                visibleItems++;
                if (item.classList.contains('hidden')) {
                    item.classList.remove('hidden');
                    item.classList.add('opacity-0');
                    item.classList.add('animate-fadeInDown');
                    item.style.animationFillMode = 'both';
                    item.style.animationDelay = `${animationInItems * 0.1}s`;
                    animationInItems++;
                }
            } else {
                item.classList.add('hidden');
                this.showMoreButton = true;
            }
        });
    },
}));
